export const isIntersectionObserverSupported = (): boolean =>
	typeof IntersectionObserver !== 'undefined';
